import styles from "../styles/index.module.css";

export default function Index({ enter }) {
return (
<div className={styles.container}>
<h1>Welcome to the Music Studio</h1>
<p>Your musician is a lazy sack of bananas, who wants you to "find meaning" in their work. 
    Unfortunately, you have to produce their music. And why is the song name so weird?</p>
<br></br>
<p>In the studio, you uncover an old, yellowed paper...</p>
<button onClick={enter}>Enter</button>
</div>
);
}